<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">
                    <el-select v-model="query.company_id" filterable multiple collapse-tags clearable placeholder="选择公司" class="handle-select mr10">
                        <el-option v-for="(row,index) in companyList" :key="index" :label="row.title" :value="row.id"></el-option>
                    </el-select>
                    <el-date-picker class="daterange mr10" v-model="query.range" type="daterange" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                    <el-button type="primary" icon="el-icon-download" @click="exportExcel">导出</el-button>
                </div>
            </div>
        </div>

        <el-table id="out-table" :data="tableData" :height="height" border class="table" ref="multipleTable" header-cell-class-name="table-header" :default-sort="{prop:'sign_date'}" :show-summary="true" :summary-method="getSummaries" v-loading="loading">
            <el-table-column type="index" width="60" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="item_check_status" label="审核状态"></el-table-column>
            <el-table-column prop="company" label="承办公司" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="suborder_sign_time" label="增项签单时间" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="wedding_income_date" label="收款时间" align="center" width="120" :show-overflow-tooltip="true" sortable></el-table-column>
            <el-table-column prop="wedding_order_date" label="婚庆合同签单日期" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="event_date" label="举办日期" align="center" width="120" :show-overflow-tooltip="true" sortable>
                <template slot-scope="scope">{{scope.row.event_date}}</template>
            </el-table-column>
            <el-table-column prop="hotel" label="酒店" width="220" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="banquet_hall_name" label="厅" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="source" label="渠道" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="newer" label="新人姓名" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="cmobile" label="客资手机号" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="wedding_totals" label="婚庆合同总额" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="subtotals" label="增项金额" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="salesman" label="签单人" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="remark" label="备注" width="100" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
    </div>
</template>

<script>
import './common.css';
import fileSaver from 'file-saver';
import xlsx from 'xlsx';

export default {
    name: 'basetable',
    data() {
        return {
            loading: false,

            sumFields: ['wedding_totals', 'subtotals'],
            height: 660,
            departmentTree: [],
            tableData: [],
            orderTypeList: [{
                id: '',
                title: '所有订单',
            },
            {
                id: 0,
                title: '普通订单',
            },
            {
                id: 98,
                title: '定金订单',
            },
            {
                id: 99,
                title: '意向金订单',
            },
            {
                id: 101,
                title: '退单',
            },
            ],
            query: {
                complete: '',
                department_id: '',
                company_id: '',
                date_type: '',
                keyword: '',
                range: []
            },
            companyList: [],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }
                ]
            }
        };
    },
    created() {
        this.height = window.innerHeight * 0.75;

        this.getData();

        // 获取部门树
        this.getDepartmentTree();

        // 获取picker
        this.getPicker();
    },
    methods: {
        getData() {
            let that = this;
            let url = '/api/statistics.fiance/weddingSuborder';
            let query = that.query;
            that.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.loading = false;
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.getData();
        },
        // 获取部门树
        getDepartmentTree() {
            let url = '/api/ucenter.department/getDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.departmentTree = response.data.tree;
            });
        },
        // 获取PIcker
        getPicker() {
            let url = '/api/statistics.picker/items';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.companyList = response.data.companyList;
            });
        },
        handleCascader(e) {
            let last = e.length - 1;
            this.query.department_id = e[last];
        },
        exportExcel() {
            /* 从表生成工作簿对象 */
            var wb = xlsx.utils.table_to_book(document.querySelector('#out-table'));
            /* 获取二进制字符串作为输出 */
            var wbout = xlsx.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                fileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    //设置导出文件名称
                    'sheetjs.xlsx'
                );
            } catch (e) {
            }
            return wbout;
        },
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总价';
                    return;
                }

                if (this.sumFields.indexOf(column.property) < 0) {
                    sums[index] = '';
                    return;
                }

                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    let sum = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);

                    sums[index] = sum.toFixed(2);
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        }
    }
};
</script>
<style lang="less">
@import url('@/assets/css/common.less');
</style>
